module.exports = __webpack_public_path__ + "static/media/door-closed.ab135951.svg";